<section class="all-systems" id="all-systems">
  <div class="all-systems__header">
    <div class="all-systems__title-row">
      <div class="all-systems__title-left">
        <h2 class="all-systems__title">{{ title }}</h2>
      </div>
      <div class="all-systems__search" *ngIf="showInlineSearch">
        <span nz-icon nzType="search" nzTheme="outline" class="all-systems__search-icon"></span>
        <input
          type="text"
          class="all-systems__search-input"
          [placeholder]="'dashboard.searchSystemPlaceholder' | translate"
          [ngModel]="searchKeyword"
          (ngModelChange)="onSearchInput($event)"
        />
      </div>
    </div>
    <div class="all-systems__tabs">
      <button
        *ngFor="let cat of categories; trackBy: trackByCategory"
        type="button"
        class="all-systems__tab"
        [class.all-systems__tab--active]="selectedCategory === cat.id"
        (click)="selectCategory(cat.id)">
        {{ cat.id === 'all' ? ('dashboard.all' | translate) : cat.label }}
      </button>
    </div>
  </div>

  <nz-spin [nzSpinning]="loading">
    <div class="all-systems__grid" *ngIf="systems.length > 0">
      <a *ngFor="let system of systems; trackBy: trackBySystem"
         [href]="system.homeRedirectUri"
         target="_blank"
         rel="noopener noreferrer"
         class="all-systems__card"
         [attr.title]="system.name"
         nz-popover
         [nzPopoverContent]="popoverTemplate"
         nzPopoverPlacement="top"
         nzPopoverTrigger="hover"
         [nzPopoverMouseEnterDelay]="0.4">
        <div class="all-systems__card-icon">
          <img [src]="getSystemIcon(system)" [alt]="system.name" />
        </div>
        <div class="all-systems__card-body">
          <div class="all-systems__card-name">{{ system.name }}</div>
          <div class="all-systems__card-desc">{{ getCardSubtitle(system) }}</div>
        </div>
        <button
          type="button"
          class="all-systems__card-star"
          [class.all-systems__card-star--active]="system.isPinned"
          [title]="system.isPinned ? ('dashboard.unfavorite' | translate) : ('dashboard.favorite' | translate)"
          (click)="onTogglePin(system.id, $event)">
          <i class="fas" [ngClass]="system.isPinned ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
        </button>

        <ng-template #popoverTemplate>
          <div class="system-popover">
            <h4 class="system-popover__title">{{ system.name }}</h4>
            <p class="system-popover__desc">{{ system.description || ('dashboard.noDescription' | translate) }}</p>
            <div class="system-popover__guide" *ngIf="system.usageGuide">
              <a [href]="system.usageGuide" target="_blank" (click)="$event.stopPropagation()" class="system-popover__guide-link">
                <i class="fas fa-book-open"></i>
                {{ 'dashboard.viewDetailGuide' | translate }}
              </a>
            </div>
          </div>
        </ng-template>
      </a>
    </div>

    <div class="all-systems__empty" *ngIf="!loading && systems.length === 0">
      {{ 'dashboard.noSystemFound' | translate }}
    </div>
  </nz-spin>


</section>
